const reasons = [
  {
    icon: 'ri-stack-line',
    title: 'Нет системы',
    desc: 'Обучение — это набор случайных тренингов, а не выстроенный процесс. Без системы знаний, повторения и оценки любое обучение даёт краткосрочный эффект, который исчезает через 2-4 недели.'
  },
  {
    icon: 'ri-user-unfollow-line',
    title: 'Нет вовлечения руководителей',
    desc: 'Руководители не участвуют в обучении, не знают, чему учат их сотрудников, и не поддерживают внедрение. Сотрудник возвращается с тренинга — а руководитель продолжает требовать «работать как раньше».'
  },
  {
    icon: 'ri-file-copy-2-line',
    title: 'Нет внедрения в работу',
    desc: 'Знания не превращаются в навыки. Сотрудники возвращаются в привычную среду, где старые скрипты и процессы не меняются. Без практики и сопровождения 80% знаний забываются за 2 недели.'
  },
  {
    icon: 'ri-bar-chart-grouped-line',
    title: 'Нет измерения результата',
    desc: 'Никто не знает, сработало ли обучение. Нет замеров до и после, нет KPI, нет отчёта для руководителя. Обучение воспринимается как «чёрный ящик» — деньги потрачены, результат неясен.'
  },
  {
    icon: 'ri-book-open-line',
    title: 'Только теория',
    desc: '80% времени — лекции и презентации. Сотрудники слушают, но не пробуют. Навыки формируются только через практику, а не через пассивное восприятие информации.'
  },
  {
    icon: 'ri-group-line',
    title: 'Программы не адаптированы',
    desc: 'Типовые тренинги, которые не учитывают специфику бизнеса, отрасль, уровень сотрудников. Обучение должно решать конкретные задачи компании, а не быть «для всех одинаковым».'
  }
];

export default function WhyTrainingFails() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Почему обучение персонала часто не работает
        </h2>
        <p className="text-lg text-gray-600 text-center mb-6 max-w-3xl mx-auto leading-relaxed">
          Проблема не в сотрудниках. Проблема в отсутствии системы.
        </p>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Компании тратят бюджеты на обучение, но не видят результатов. Причина не в том, что «сотрудники не хотят учиться». Причина — в системных ошибках организации самого процесса обучения.
        </p>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons.map((r, i) => (
            <div key={i} className="bg-gray-50 rounded-2xl p-6 border border-gray-100 hover:border-red-200 transition-all group">
              <div className="w-12 h-12 bg-red-100 rounded-xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                <i className={`${r.icon} text-xl text-red-600`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">{r.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}